import { Card } from '@sandtech-hub-monorepo/ui-kit';
import { ProgramOverviewCard } from './ProgramOverviewCard';
import { PlannedCoursesView } from '@sandtech-hub-monorepo/ui-kit-site';
import { Application, Enrollment } from '../types';

interface Props {
  enrollment: Enrollment;
  application?: Application;
}

export const PendingApplicationView = ({ enrollment, application }: Props) => {
  return (
    <Card className="px-6 py-9">
      <ProgramOverviewCard enrollment={enrollment} application={application} />
      <div className="sm:pl-16">
        <PlannedCoursesView plannedCourses={enrollment.plannedCourses} />
      </div>
    </Card>
  );
};
